import { detectionOrigins } from "../constants";

export function hasChildren(item) {
  const { routes: children } = item;

  if (children === undefined) {
    return false;
  }

  if (children.constructor !== Array) {
    return false;
  }

  if (children.length === 0) {
    return false;
  }

  return true;
}

export function isExpired(date) {
  return new Date(date).getTime() < new Date().getTime()
}

// ##############################
// // // Function that converts from hex color to rgb color
// // // Example: input = #9c27b0 => output = 156, 39, 176
// // // Example: input = 9c27b0 => output = 156, 39, 176
// // // Example: input = #999 => output = 153, 153, 153
// // // Example: input = 999 => output = 153, 153, 153
// #############################
export const hexToRgb = (input) => {
  input = input + "";
  input = input.replace("#", "");
  let hexRegex = /[0-9A-Fa-f]/g;
  if (!hexRegex.test(input) || (input.length !== 3 && input.length !== 6)) {
    throw new Error("input is not a valid hex color.");
  }
  if (input.length === 3) {
    let first = input[0];
    let second = input[1];
    let last = input[2];
    input = first + first + second + second + last + last;
  }
  input = input.toUpperCase();
  let first = input[0] + input[1];
  let second = input[2] + input[3];
  let last = input[4] + input[5];
  return (
    parseInt(first, 16) +
    ", " +
    parseInt(second, 16) +
    ", " +
    parseInt(last, 16)
  );
};

export const getSKSIDFromDetectionOrigin = (detectionOriginsArr) => {
  var skSid = []
  if (detectionOriginsArr && detectionOriginsArr?.length > 0) {
    detectionOriginsArr.forEach(origin => {
      if (origin === detectionOrigins.SONICKEY.name) skSid.push(detectionOrigins.SONICKEY.shortName)
      if (origin === detectionOrigins.FINGERPRINT.name) skSid.push(detectionOrigins.FINGERPRINT.shortName)
    });
  } else {
    skSid = [detectionOrigins.SONICKEY.shortName]
  }
  return skSid.join(", ")
}